module.exports = __webpack_public_path__ + "static/media/T3.cad0605a.jpeg";